import Vue from "vue";
import Vuex, { ModuleTree } from "vuex";

import Error from "@/App/store/Error.Store";
import Global from "@/App/store/Global.Store";
import Login from "@/Login/store/Login.Store";
import ChangePassword from "@/ChangePassword/store/ChangePassword.Store";
import TeamSelection from "@/TeamSelection/store/TeamSelection.Store";
import TruckSelection from "@/TruckSelection/store/TruckSelection.Store";
import Case from "@/Case/store/Case.Store";
import CaseTransfer from "@/Case/store/CaseTransfer.Store";
import PubNubSubscription from "@/App/store/PubNubSubscription.Store";
import PushNotification from "@/App/store/PushNotification.Store";
import Authenticate from "@/App/store/Authenticate.Store";
import GpsSource from "@/GpsSource/store/GpsSource.Store";
import Voip from "@/Case/voip/Voip.Store";
import { FeedbackStore } from "../components/feedback";
import CaseFeedback from "@/CaseFeedback/store/CaseFeedback.Store";
import CaseFeedbackSettings from "@/CaseFeedback/store/CaseFeedbackSettings.Store";

Vue.use(Vuex);

const Modules = {
  modules: {
    Global,
    Error,
    Login,
    TeamSelection,
    TruckSelection,
    Case,
    CaseTransfer,
    PubNubSubscription,
    ChangePassword,
    PushNotification,
    Authenticate,
    Voip,
    FeedbackStore,
    CaseFeedback,
    CaseFeedbackSettings,
  } satisfies ModuleTree<unknown>,
};

if (window.electron) {
  Modules.modules["GpsSource"] = GpsSource;
}

export const Store = new Vuex.Store(Modules);

export default Store;
